import { useState, useCallback, useEffect } from 'react';

export type CostCenterTab = 'materials' | 'products' | 'recipes' | 'services' | 'fixed_costs';

export function useCostCenterTabs(initialTab: CostCenterTab = 'materials') {
  const [mainTab, setMainTab] = useState<CostCenterTab>(initialTab);

  useEffect(() => {
    if (initialTab) {
      setMainTab(initialTab);
    }
  }, [initialTab]);

  const changeTab = useCallback((tab: CostCenterTab): void => {
    setMainTab(tab);
    window.scrollTo(0, 0);
  }, []);

  return {
    mainTab,
    changeTab,
  };
}
